import React from 'react';
import { Button, DatePicker, Form, Input, Modal, Space } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';
import InputNumber from 'components/input-number';
import ImagePicker from 'components/pickers/image/MultiImagePicker';
import { formatCurrency } from 'utils/number';
import { formatOnlyDate } from 'utils/date';
import { getOrderPaymentMethodLabel } from '../paymentMethodLabel';

const DesktopOrderPayment = ({ viewModel }) => {
  const {
    open,
    order,
    paymentHistories,
    showPaymentForm,
    savingPayment,
    form,
    openPaymentForm,
    closePaymentForm,
    savePayment,
    onClose,
    showUpdateDebtModal,
  } = viewModel;
  const paymentMethodLabel = getOrderPaymentMethodLabel(order);

  return (
    <>
      <Modal
        title="Thanh Toán"
        open={open}
        onCancel={onClose}
        destroyOnHidden
        footer={
          <Space>
            <Button onClick={onClose}>Đóng</Button>
            <Button type="primary" onClick={openPaymentForm}>
              <CreditCardOutlined /> Nhận thanh toán
            </Button>
          </Space>
        }
      >
        <Space style={{ width: '100%' }} direction="vertical">
          <label>Chi tiết</label>
          <table className="tbl_order" style={{ width: '100%' }}>
            <colgroup>
              <col style={{ width: 75 }} />
            </colgroup>
            <tbody>
              <tr>
                <td colSpan={2}>Phương thức thanh toán</td>
                <td style={{ textAlign: 'right' }}>{paymentMethodLabel}</td>
              </tr>
              <tr>
                <td>Ngày</td>
                <td>Nội dung</td>
                <td>Số tiền</td>
              </tr>
              {paymentHistories.map((item) => (
                <tr key={item.payment.id}>
                  <td style={{ width: 150 }}>
                    <Button type="link" onClick={() => showUpdateDebtModal(item.payment.id)}>
                      {formatOnlyDate(item.payment.date)}
                    </Button>
                  </td>
                  <td style={{ width: 150 }}>{item.payment.description}</td>
                  <td style={{ textAlign: 'right', width: 150 }}>{formatCurrency(item.amount)}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={2}>Tổng tiền</td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(order?.total_amount)}</td>
              </tr>
              <tr>
                <td colSpan={2}>Đã thanh toán</td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(order?.paid_amount)}</td>
              </tr>
              <tr>
                <td colSpan={2}>Còn lại</td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(order?.remain_amount)}</td>
              </tr>
            </tbody>
          </table>
        </Space>
      </Modal>

      <Modal
        title="Nhận thanh toán"
        open={showPaymentForm}
        onOk={savePayment}
        okText="Lưu"
        okButtonProps={{ loading: savingPayment }}
        onCancel={closePaymentForm}
        destroyOnHidden
      >
        <Form layout="vertical" form={form}>
          <Form.Item name="id" hidden />
          <Form.Item
            name="amount"
            label="Số tiền"
            rules={[{ required: true, message: 'Bạn phải nhập số tiền' }]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            name="description"
            label="Nội dung"
            rules={[{ required: true, message: 'Bạn phải nhập nội dung' }]}
          >
            <Input placeholder="Nội dung" />
          </Form.Item>
          <Form.Item
            name="date"
            label="Ngày thanh toán"
            rules={[{ required: true, message: 'Bạn phải nhập ngày' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="images" label="Hình ảnh">
            <ImagePicker />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default DesktopOrderPayment;
